import m01 from "./_01";
import m04 from "./_04";
import m06 from "./_06";
import m07 from "./_07";
import m08 from "./_08";
import m10 from "./_10";
import m11 from "./_11";

export default [
	...m01,
	...m04,
	...m06,
	...m07,
	...m08,
	...m10,
	...m11
];
